import { createFileRoute } from "@tanstack/react-router";
import { AuthPage } from "@/components/auth-page";

export const Route = createFileRoute("/magic-link")({
	component: MagicLinkPage,
	ssr: false,
});

function MagicLinkPage() {
	return <AuthPage view="MAGIC_LINK" />;
}
